<script lang="ts">
    import Footer from "./footer/Footer.svelte";
    import Head from "./header/Head.svelte";
    import Navbar from "./header/Navbar.svelte";
    import { appManager } from "./AppManagerStore";
    import AngleLeft from "./svg/shapes/AngleLeft.svelte";
    import { _ } from "svelte-i18n";

    const print = () => {
      window.print();
    }
  </script>
  
  <svelte:head>
    <title>ANYWAYS | {$_("terms.header.title")}</title>
  </svelte:head>
  
  <Navbar background="light" isFluid={false} />
  
  <section class="pt-8 pt-md-11 pb-8 pb-md-14">
    <div class="container">
      <!-- Header Row -->
      <div class="row align-items-center">
        <div class="col-12 col-md">
          <h1 class="display-4 mb-2">{$_("terms.header.title")}</h1>
          <p class="fs-lg text-gray-700 mb-md-0">{$_("terms.header.updatedDate")}</p>
        </div>
        <div class="col-auto">
          <button class="btn btn-primary-soft" on:click={print}>{$_("terms.header.printButton")}</button>
        </div>
      </div>
  
      <div class="row">
        <div class="col-12">
          <hr class="my-6 my-md-8" />
        </div>
      </div>
  
      <div class="row">
        <!-- Main Content -->
        <div class="col-12 col-md-8">
          <p class="text-gray-800">{$_("terms.intro.paragraph1")}</p>
          <p class="text-gray-800">{$_("terms.intro.paragraph2")}</p>
          <p>{$_("terms.intro.paragraph3")}</p>
  
          <!-- Bullet 1 -->
          <div class="d-flex">
            <span class="badge badge-rounded-circle bg-success-soft mt-1 me-4">
              <i class="fe fe-check"></i>
            </span>
            <p class="text-gray-800">{$_("terms.bullets.0.text")}</p>
          </div>
  
          <!-- Bullet 2 -->
          <div class="d-flex">
            <span class="badge badge-rounded-circle bg-success-soft mt-1 me-4">
              <i class="fe fe-check"></i>
            </span>
            <p class="text-gray-800">{$_("terms.bullets.1.text")}</p>
          </div>
  
          <!-- Bullet 3 -->
          <div class="d-flex">
            <span class="badge badge-rounded-circle bg-success-soft mt-1 me-4">
              <i class="fe fe-check"></i>
            </span>
            <p class="text-gray-800">{$_("terms.bullets.2.text")}</p>
          </div>
  
          <!-- Bullet 4 -->
          <div class="d-flex">
            <span class="badge badge-rounded-circle bg-success-soft mt-1 me-4">
              <i class="fe fe-check"></i>
            </span>
            <p class="text-gray-800">{$_("terms.bullets.3.text")}</p>
          </div>
  
          <!-- Bullet 4 -->
          <div class="d-flex">
            <span class="badge badge-rounded-circle bg-success-soft mt-1 me-4">
              <i class="fe fe-check"></i>
            </span>
            <p class="text-gray-800">{$_("terms.bullets.4.text")}</p>
          </div>
  
  
          <!-- Bullet 5 -->
          <div class="d-flex">
            <span class="badge badge-rounded-circle bg-success-soft mt-1 me-4">
              <i class="fe fe-check"></i>
            </span>
            <p class="text-gray-800">{$_("terms.bullets.5.text")}</p>
          </div>
        </div>
  
        <!-- Sidebar -->
        <div class="col-12 col-md-4">
          <div class="card shadow-light-lg">
            <div class="card-body">
              <h4>{$_("terms.aside.title")}</h4>
              <p class="fs-sm text-gray-800 mb-5">{$_("terms.aside.paragraph")}</p>
  
              <h6 class="fw-bold text-uppercase text-gray-700 mb-2">
                {$_("terms.aside.contactTitle")}
              </h6>
              <p class="fs-sm mb-0">
                <a href="mailto:info@anyways.eu" class="text-reset">
                  {$_("terms.aside.contactEmail")}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <Footer bgClass="bg-gray-200" />
  